import { render, staticRenderFns } from "./ModalIntegrarRepasseMultiplo.vue?vue&type=template&id=9b80036c"
import script from "./ModalIntegrarRepasseMultiplo.vue?vue&type=script&lang=ts"
export * from "./ModalIntegrarRepasseMultiplo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports